import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { LANGUAGES } from '../languages';

export default function LanguageSelection() {
  const { roomCode } = useParams();
  const navigate = useNavigate();
  const [language, setLanguage] = useState('English');
  const [customLanguage, setCustomLanguage] = useState('');
  const [error, setError] = useState('');
  const chosenLanguage = customLanguage.trim() || language;

  const continueToReader = (event) => {
    event.preventDefault();
    if (!chosenLanguage) {
      setError('Choose or enter a language.');
      return;
    }
    navigate(`/room/${roomCode}/read?lang=${encodeURIComponent(chosenLanguage)}`);
  };

  return (
    <div className="language-page">
      <section className="page-card language-card" aria-labelledby="language-title">
        <h2 id="language-title">Join a Translation Session</h2>
        <p>Room <span className="room-code-badge">{roomCode}</span></p>
        {error && <div className="alert alert-error" role="alert">{error}</div>}
        <form onSubmit={continueToReader}>
          <label htmlFor="reader-language">Choose Language</label>
          <select id="reader-language" className="form-control language-select" value={language} onChange={(event) => { setLanguage(event.target.value); setCustomLanguage(''); }} disabled={Boolean(customLanguage.trim())}>
            {LANGUAGES.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
          <label htmlFor="custom-language" className="custom-language-label">Or Enter Language Name</label>
          <input id="custom-language" className="form-control" value={customLanguage} onChange={(event) => setCustomLanguage(event.target.value)} placeholder="e.g., Swahili (Overrides dropdown)" />
          <button type="submit" className="btn btn-primary btn-wide">Join Session</button>
        </form>
      </section>
    </div>
  );
}
